import React from 'react'
import { Box, Toolbar, Typography } from "@mui/material";
import Footer from '../Component/Footer';
import { useLanguage } from '../context/LanguageContext';
import Awareness from '../Component/Awareness';
import Header from "../Component/header";
import DesktopFooter from "../Component/Desktopfooter";

const Awarenesspage = () => {
    const { t } = useLanguage();
  return (
    <>
    <div className='text-Wrapper'>
              <Header/>
               <Box>
                    <Toolbar>
                       <Awareness />
                    </Toolbar>
                </Box>
            </div>
             <DesktopFooter/>
             <Footer />
    </>
  )
}

export default Awarenesspage
